export default __webpack_public_path__ + "static/media/map-mo.f681c426.jpg";